import {SingletonCollection} from 'util/backbone-extensions';
import * as logging from 'util/Logging';

interface LaunchDarklyFlagAttrs {
  flagKey: string;
  flagValue: boolean;
}

export class LaunchDarklyFlag extends Backbone.Model {
  flagKey!: string;
  flagValue!: boolean;

  override initialize(attrs: LaunchDarklyFlagAttrs): void {
    this.id = attrs.flagKey;
    this.flagKey = attrs.flagKey;
    this.flagValue = attrs.flagValue;
  }
}

/**
 * A global Backbone SingletonCollection caching all LaunchDarkly flag values.
 *
 * The purpose of this Collection is to allow LaunchDarklyListeningView instances to listen for LaunchDarkly
 * initialization with Backbone listeners.
 */
export class LaunchDarklyFlags extends SingletonCollection<LaunchDarklyFlag> {
  override initialize(): void {
    window
      .ldClient!.waitForInitialization(5)
      .then(() => {
        const allFlags = window.ldClient!.allFlags();
        const allFlagValues = Object.entries(allFlags).map(
          ([flagKey, flagValue]) => new LaunchDarklyFlag({flagKey, flagValue})
        );
        this.set(allFlagValues);
      })
      .catch((err) => {
        logging.warn(
          `LDClient initialization failed or timed out; Backbone consumers will fallback to defaults. Original error message: ${err}`
        );
      });
  }
}
